<template>
  <!--<section class="it-hero-wrapper bg-dark text-white">-->


  <div class="navbar-container py-3">

    <nav class="navbar-hero d-flex align-items-center">

      <ul class="nav flex-wrap">
        <li v-for="menu in visibleMenus" :key="menu.label" class="nav-item mx-3 position-relative">
          <!-- Se ha figli -->
          <template v-if="menu.children && menu.children.length">
            <div class="nav-link fw-semibold d-flex align-items-center" @click="toggleMenu(menu.label)">
              <i :class="menu.icon + ' me-2'"></i>{{ menu.label }}
              <i class="bi ms-2" :class="openMenus.includes(menu.label) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </div>

            <!-- Submenu -->
            <ul v-if="openMenus.includes(menu.label)" class="submenu list-unstyled shadow rounded p-2 mt-2">
              <li v-for="child in menu.children" :key="child.label" class="submenu-item">
                <a class="submenu-link d-block px-3 py-1" @click="$emit('change-view', child.view)">
                  <i :class="child.icon + ' me-2'"></i>{{ child.label }}
                </a>
              </li>
            </ul>
          </template>

          <!-- Se è voce singola 
          <template v-else>
            <a class="nav-link fw-semibold d-flex align-items-center" :class="{ active: isActive(menu.view) }"
              @click="selectedView = menu.view; $emit('change-view', menu.view)">
              <i :class="menu.icon + ' me-2'"></i>{{ menu.label }}
            </a>
          </template>-->
          <template v-else>
            <a class="nav-link fw-semibold d-flex align-items-center" :class="{ active: isActive(menu.view) }"
              @click="handleMenuClick(menu)">
              <i :class="menu.icon + ' me-2'"></i>{{ menu.label }}
            </a>
          </template>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { menuMap } from '../../components/menuMap.js';
import { useEventListener, useEventEmitter } from '../../services/eventBus.js';

export default {
  name: 'Navbar',
  props: {
    currentView: String,
    userPermissions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      menuMap,
      openMenus: [],
      selectedView: 'QuestionsView'
    };
  },
  computed: {
    visibleMenus() {
      return this.menuMap
        .map(menu => {
          if (!menu) return null;
          if (menu.children && Array.isArray(menu.children)) {
            const visibleChildren = menu.children.filter(child =>
              child.requiredPermissions?.some(p => this.$root.user?.permissions.includes(p))
            );
            return visibleChildren.length
              ? { ...menu, children: visibleChildren }
              : null;
          } else if (menu.requiredPermissions?.some(p => this.$root.user?.permissions.includes(p))) {
            return menu;
          }
          return null;
        })
        .filter(Boolean);
    }
  },
  methods: {
    toggleMenu(label) {
      if (this.openMenus.includes(label)) {
        this.openMenus = this.openMenus.filter(l => l !== label);
      } else {
        this.openMenus.push(label);
      }
    },
    isActive(view) {
      return this.selectedView === view;
    },
    /**handleMenuClick(menu) {
      if (menu.label === 'NUOVO QUESITO') {
        this.$emit('show-new-question-modal')
        this.selectedView = menu.view;
        this.$emit('change-view', menu.view);
      } else {
        this.selectedView = menu.view;
        this.$emit('change-view', menu.view);
      }

      this.selectedView = menu.view;
      this.$emit('change-view', menu.view);
      if (menu.label === 'NUOVO QUESITO') {
        this.$emit('show-new-question-modal')
      }

    },*/
    handleMenuClick(menu) {
      this.selectedView = menu.view

      const { emit } = useEventEmitter();
      emit('set-navbar-view', menu.view);
      if (menu.label === 'NUOVO QUESITO') {
        this.$emit('show-new-question-modal', menu.view)
      } else {
        //this.selectedView = menu.view
        this.$emit('change-view', menu.view)
      }

      /*this.selectedView = menu.view
      this.$emit('change-view', menu.view)*/
    },

  },
  mounted() {
    const observer = new MutationObserver(() => {
      const el = document.querySelector('.navbar .navbar-collapsable');
      if (el) {
        el.style.setProperty('top', '0', 'important');
        el.style.setProperty('position', 'relative', 'important');
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  },
  created() {
    useEventListener('set-navbar-view', (viewName) => {
      this.selectedView = viewName;
    });
  },
  emits: ['change-view', 'show-new-question-modal'],
};
</script>

<style scoped>
.navbar-container {
  width: 70%;
  margin: 0 auto;
  text-align: left;
  padding: 0;
  /* 🔹 elimina padding interno del container */
}

.navbar {
  padding: 0 !important;
  /* 🔹 forza la rimozione padding */
}

.navbar-hero {
  display: flex;
  align-items: center;
  /* ✅ centra verticalmente il contenuto */
  justify-content: flex-start;
  height: 60px;
  /* ✅ altezza fissa coerente con header */
  padding: 0;
  margin: 0;
}

.nav-item {
  display: flex;
  align-items: center;
  /* ✅ centra icona + testo */
  height: 100%;
  /* ✅ uniforma altezza */
}

.nav-link {
  display: flex;
  align-items: center;
  /* ✅ centra contenuto in verticale */
  height: 100%;
  /* ✅ forza la stessa altezza della navbar */
  padding: 0 0.75rem;
  /* ✅ rimuove padding verticale, lascia orizzontale */
  line-height: 1;
  /* ✅ evita disallineamento testo */
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.2s ease-in-out;
}

.nav-link:hover,
.nav-link.active {
  color: #e0e0e0;
  text-decoration: underline;
}

/** .navbar-collapsable {
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}*/

.nav.flex-wrap {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
  height: 100%;
}

:deep(.navbar-collapsable) {
  position: relative !important;
  top: 0em !important;
}

.it-header-navbar-wrapper .container-xxl,
.it-header-navbar-wrapper .container,
.it-header-navbar-wrapper .col-12,
.it-header-navbar-wrapper .navbar-container {
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* === Submenu === */
.submenu {
  position: absolute;
  top: 2.2rem;
  left: 0;
  min-width: 200px;
  background-color: #212529;
  z-index: 10;
}

.submenu-link {
  color: white;
}

.submenu-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
</style>

<style>
.navbar .navbar-collapsable {
  top: 0 !important;
  position: relative !important;
}
</style>